import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewInsumoCosto = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'insumo_costo',
        name: 'Costear Consumo',
        component: ViewInsumoCosto,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
